import { BurialType, GRAVE_CONFIG, MAUSOLEUM_CONFIG } from 'src/constants';
import type { IDeceased } from 'src/interfaces';

export function getGraveLocation(deceased: IDeceased) {
  const isMausoleum = !!deceased.mausoleum;
  const data = isMausoleum ? deceased.mausoleum : deceased.grave;
  const config = isMausoleum ? MAUSOLEUM_CONFIG : GRAVE_CONFIG;

  return config
    .filter(({ field }) => !!data?.[field])
    .map(({ field, label }) => {
      if (field === 'type' && data) {
        return `${BurialType[data.type] ?? ''} ${data.no}`;
      }

      return `${label} ${data?.[field]}`;
    })
    .join(', ');
}
